import { BaseAction } from "../../../core/actions/BaseAction";
import { isEmpty } from "../../../Lib/Utils/validationUtil";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookingResponse, IPassenger } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IOnChangePassengerCheckBoxActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/ServiceRequestActionParams";

class OnChangePassengerCheckBoxAction extends BaseAction<IDefaultActionResult, IOnChangePassengerCheckBoxActionParams> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }

        try {
            const { event, passengerId, type, key } = this.params!
            const modifiedPassengerName: any = getRecoilStateValue("modifiedPassengerNameAtom") || {}
            let modifiedPassenger = {
                ...modifiedPassengerName || {},
            };
            if (type === "CHECKBOX_CHANGE") {
                if (event.target.checked) {
                    const booking: IBookingResponse = getRecoilStateValue("bookingResponseAtom") || {} as IBookingResponse
                    let passenger: any = {}
                    if (booking) {
                        passenger = (booking?.booking?.passengers || []).find((d: IPassenger) => d.id === passengerId)
                    }                    
                    const oldData = {
                        ...(modifiedPassengerName || {}),
                        [passengerId]: {
                            firstName: "",
                            lastName: "",
                            oldName: `${(passenger?.detail?.firstName || "")} ${(passenger?.detail?.lastName || "")}`
                        },
                    };
                    modifiedPassenger = oldData
                    updateRecoilState("modifiedPassengerNameAtom", oldData);
                } else {
                    const { [passengerId]: _, ...rest } = modifiedPassengerName;
                    modifiedPassenger = rest
                    updateRecoilState("modifiedPassengerNameAtom", rest);
                }
            } else if (type === "ONCHANGE_PASSENGER_NAME") {
                let oldData = {
                    ...modifiedPassengerName || {},
                };
                oldData[passengerId] = {
                    ...oldData[passengerId],
                    [key]: event.target.value,
                };
                modifiedPassenger = oldData
                updateRecoilState("modifiedPassengerNameAtom", oldData);
            }
            /**
            * Find how many passenger we have and how many passenger name filled
            * If all passenger name filled then enable the submit button
            * otherwise disable the submit button.            
            */
            const passengers = Object.keys(modifiedPassenger).filter(
                (d) => !isEmpty(modifiedPassenger[d].firstName) && !isEmpty(modifiedPassenger[d].lastName)
            );
            if (Object.keys(modifiedPassenger).length > 0) {
                if (Object.keys(modifiedPassenger).length === passengers.length) updateRecoilState("submitRequestButtonDisabledAtom", false)
                else updateRecoilState("submitRequestButtonDisabledAtom", true)
            } else updateRecoilState("submitRequestButtonDisabledAtom", true)
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const onChangePassengerCheckBoxAction = new OnChangePassengerCheckBoxAction()